import AddShoppingCartRoundedIcon from "@mui/icons-material/AddShoppingCartRounded";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import NumberInput from "../NumberInput";

const FilterCard = ({
  item,
  quantity,
  handleQuantityChange,
  handleAddToCart,
  isGuest,
}) => {
  const theme = useTheme();
  const storageUrl = process.env.REACT_APP_STORAGE_URL;

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "row",
        height: "100%",
        transition: "all 0.3s",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        },
        bgcolor: theme.palette.grey[50],
        overflow: "hidden",
        boxSizing: "border-box",
      }}
      elevation={3}
    >
      <CardContent
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "16px",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          gap={"10px"}
        >
          <Box
            sx={{
              maxHeight: 50,
              maxWidth: 50,
              overflow: "hidden",
              my: 2,
              flexShrink: 0,
            }}
          >
            <img
              src={
                item.s_icon
                  ? `https://minio.jlfiltersystem.dk/uploads/${item.s_icon}`
                  : "/images/filter_1836109.png"
              }
              alt={item.s_name}
              style={
                item.s_icon
                  ? { width: "100%", height: "auto" }
                  : { width: "80%", height: "auto" }
              }
            />
          </Box>

          <Box sx={{ flexGrow: 1 }}>
            {!isGuest && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                JL Number: {item.jl_number}
              </Typography>
            )}
            <Typography variant="h8" sx={{ fontWeight: "bold", mb: 1 }}>
              {isGuest
                ? item.name
                : item.cross_references?.map((ref, index) => (
                    <div key={index}>
                      {ref.name} ({ref.supplier})<br />
                    </div>
                  ))}
            </Typography>
            {item.s_name !== null && (
              <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                Type: {item.s_name}
              </Typography>
            )}
          </Box>
        </Box>

        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="flex-end"
        >
          {!isGuest && (
            <Box sx={{ textAlign: "right", flexShrink: 0 }}>
              {item.price === null ? (
                <Typography variant="body2" color={"#FF9100"}>
                  <strong>Ring for pris</strong>
                </Typography>
              ) : item.price?.Unit_Price ===
                item.prices?.Unit_Price_Discount ? (
                <Typography variant="body1" color={"#00712D"}>
                  <strong> {item.price?.Unit_Price.toFixed(2)} Dkk</strong>
                </Typography>
              ) : (
                <Typography variant="body1" color={"#00712D"}>
                  <strong>
                    {item.price?.Unit_Price_Discount.toFixed(2)} Dkk{" "}
                  </strong>
                </Typography>
              )}
            </Box>
          )}
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="space-between"
          >
            <NumberInput
              value={quantity[item.id] || 1}
              onChange={(e, newVal) => {
                if (newVal > 99) return;
                handleQuantityChange(item.id, newVal);
              }}
              min={1}
              max={99}
              sx={{ flexShrink: 0 }}
            />
            <Box
              sx={{
                width: "47px",
                height: "40px",
                backgroundColor: "#424242",
                borderRadius: "5px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                "&:hover": {
                  backgroundColor: "#686868",
                },
                flexShrink: 0,
              }}
            >
              <IconButton
                aria-label="Add To Cart"
                size="large"
                onClick={() => handleAddToCart(item)}
              >
                <AddShoppingCartRoundedIcon sx={{ color: "#ffffff" }} />
              </IconButton>
            </Box>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default FilterCard;
